import { render, staticRenderFns } from "./UnifiedContentList.vue?vue&type=template&id=a1270710&scoped=true&"
import script from "./UnifiedContentList.vue?vue&type=script&lang=js&"
export * from "./UnifiedContentList.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedContentList.vue?vue&type=style&index=0&id=a1270710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1270710",
  null
  
)

export default component.exports